/**
 * Copy of Petal's Tippy Hook. Needed to make modifications to functionality, so wanted to preserve the original.
 */
import tippy, { roundArrow } from "tippy.js";

const MSTippyHook = {
  mounted() {
    this.initializeTippy(this.el);
  },
  updated() {
      if(this.tippyInstance) {
        this.tippyInstance.setContent(this.el.dataset.tippyContent)
      }
  },
  initializeTippy(el) {
    const disableOnMount = el.dataset.disableTippyOnMount === "true";
    const interactive = el.dataset.interactive === "true" || false;
    const delay = el.dataset.delay || 0;

    this.tippyInstance = tippy(el, {
      interactive: interactive,
      allowHTML: true,
      touch: "hold",
      delay: [0, delay], // [showDelay, hideDelay] - in milliseconds
      theme: "ms-light",
      arrow: roundArrow + roundArrow,
    });

    if (disableOnMount) {
      this.tippyInstance.disable();
    }
  },
};

export default MSTippyHook;
